import type { ReactNode } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";

/** Header + content + footer, applied to every publicly reachable page. */
export function PublicLayout({ children, signedIn }: { children: ReactNode; signedIn: boolean }) {
  return (
    <div className="site">
      <SiteHeader signedIn={signedIn} />
      <main className="site-main">{children}</main>
      <SiteFooter />
    </div>
  );
}
